import I18n from 'I18n';
import { Fragment } from 'react';
import { getFullUrl } from 'hubspot-url-utils';
import Raven from 'raven-js';
import ChatflowName from 'automation-ui-references/customer-data/ChatflowName';
import IntegrationName from 'automation-ui-references/customer-data/IntegrationName';
import OwnerName from 'automation-ui-references/customer-data/OwnerName';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import PlatformFlowName from 'automation-ui-references/customer-data/PlatformFlowName';
import UserName from 'automation-ui-references/customer-data/UserName';
import ContactListName from 'automation-ui-references/customer-data/ContactListName';
import ObjectListName from 'automation-ui-references/customer-data/ObjectListName';
import ObjectTypeName from 'automation-ui-references/object-types/ObjectTypeName';
import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { editPropertyUrl, formUrl, inboundDbObjectUrlByObjectTypeId, notificationsSettingsUrl, recycleBinUrl, taskBoardUrl } from 'automation-ui-references/routing/hubspotUrls';
import { flowChangesUrl } from 'automation-ui-routing/workflowsUrls';
import UILink from 'UIComponents/link/UILink';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const parseDataField = (portalId, dataField) => {
  switch (dataField.type) {
    // TODO: We need the path suffix here
    case 'ACTION_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: `${getFullUrl('app')}/workflows/${dataField.portalId}/platform/flow/${dataField.flowId}/edit/actions/${dataField.actionId}`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.actionUrl"
        })
      });
    case 'CHATFLOW':
      return /*#__PURE__*/_jsx(ChatflowName, {
        id: dataField.chatflowId
      });
    case 'LIST_LINK':
      return /*#__PURE__*/_jsx(ContactListName, {
        id: dataField.listId
      });
    case 'INBOUNDDB_LIST_LINK':
      return /*#__PURE__*/_jsx(ObjectListName, {
        id: dataField.listId
      });
    case 'DATETIME':
      return I18n.moment.portalTz(dataField.datetime).format('lll z');
    case 'EDIT_WORKFLOW_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: `${getFullUrl('app')}/workflows/${portalId}/platform/flow/${dataField.flowId}/edit`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.editWorkflowLink"
        })
      });
    case 'EMAIL_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: `${getFullUrl('app')}/email/${portalId}/details/${dataField.emailContentId}`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.emailLink"
        })
      });
    case 'ENROLLMENT_FILTERS_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: `${getFullUrl('app')}/workflows/${portalId}/platform/flow/${dataField.flowId}/edit/actions/enrollment/filters`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.enrollmentFiltersLink"
        })
      });
    case 'EVENT_LINK':
    case 'PAGE_LINK':
      // Neither of these are in use today, so don't do anything
      return null;
    case 'FLOW_DETAIL_LINK_ACTION_LOGS':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: `${getFullUrl('app')}/workflows/${dataField.portalId}/details/${dataField.flowId}/action-logs`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.flowDetailLinkActionLogs"
        })
      });
    case 'FORM_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: formUrl(dataField.formId),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.formLink"
        })
      });
    case 'GOAL_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: `${getFullUrl('app')}/workflows/${portalId}/platform/flow/${dataField.flowId}/goals`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.goalLink"
        })
      });
    case 'INTEGRATION':
      return /*#__PURE__*/_jsx(IntegrationName, {
        id: dataField.integrationId
      });
    case 'INVALID_PROPERTIES':
      return Array.isArray(dataField.invalidProperties) && /*#__PURE__*/_jsx(FormattedList, {
        children: dataField.invalidProperties.map(propertyName => /*#__PURE__*/_jsx(PropertyName, {
          objectTypeId: dataField.objectTypeId,
          propertyName: propertyName
        }, propertyName))
      });
    case 'NOTIFICATION_SETTINGS_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: notificationsSettingsUrl('', ''),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.notificationSettingsLink"
        })
      });
    case 'NUMBER':
      return /*#__PURE__*/_jsx(FormattedNumber, {
        value: dataField.number
      });
    case 'OBJECT_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: inboundDbObjectUrlByObjectTypeId(dataField.objectTypeId, dataField.objectId),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.objectLink"
        })
      });
    // TODO: Get rid of OBJECT_PROPERTY_LINK?
    case 'OBJECT_PROPERTY_LINK':
    case 'PROPERTY_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: editPropertyUrl(dataField.objectTypeId, dataField.propertyName),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.propertyLink"
        })
      });
    case 'OBJECT_TYPE':
      // TODO: Need capitalization here
      return /*#__PURE__*/_jsx(ObjectTypeName, {
        objectTypeId: dataField.objectTypeId,
        isPlural: dataField.isPlural,
        isCapitalized: false
      });
    case 'OBJECT_TYPE_NAME':
      // TODO: Duplicate?
      return dataField.objectTypeName;
    case 'OWNER':
      return dataField.ownerId ? /*#__PURE__*/_jsx(OwnerName, {
        id: dataField.ownerId
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-log-events.messageOptionUtils.create-object.noAssignment"
      });
    case 'PROPERTY_NAME':
      return /*#__PURE__*/_jsx(PropertyName, {
        objectTypeId: dataField.objectTypeId,
        propertyName: dataField.propertyName
      });
    case 'RECYCLE_BIN_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: recycleBinUrl(dataField.objectTypeId),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.recycleBinLink"
        })
      });
    case 'REENROLLMENT_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: `${getFullUrl('app')}/workflows/${portalId}/platform/flow/${dataField.flowId}/edit/actions/enrollment/reenrollment`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.reenrollmentLink"
        })
      });
    case 'REVISION_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: flowChangesUrl(dataField.flowId),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.revisionLink"
        })
      });
    case 'SALESFORCE_TASK_URL':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: dataField.url,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.salesforceTaskUrl"
        })
      });
    case 'MISSING_PROPERTIES':
      // TODO: Should this be consolidated with `INVALID_PROPERTIES`?
      return /*#__PURE__*/_jsx(FormattedList, {
        children: dataField.missingProperties.map(propertyName => /*#__PURE__*/_jsx(PropertyName, {
          objectTypeId: dataField.objectTypeId,
          propertyName: propertyName
        }, propertyName))
      });
    case 'SUPPORT_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: dataField.url,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.supportLink"
        })
      });
    case 'SUPPRESSION_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: `${getFullUrl('app')}/workflows/${portalId}/platform/flow/${dataField.flowId}/settings#suppressions`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.suppressionLink"
        })
      });
    case 'TASK_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: taskBoardUrl(dataField.taskId),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.taskLink"
        })
      });
    case 'TEXT':
      return dataField.text;
    case 'USER':
      return /*#__PURE__*/_jsx(UserName, {
        id: dataField.userId
      });
    case 'WEBHOOK_LINK':
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: dataField.url,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dynamicLogEvents.links.webhookUrl"
        })
      });
    case 'WORKFLOW':
      return /*#__PURE__*/_jsx(PlatformFlowName, {
        id: dataField.flowId
      });
    default:
      {
        Raven.captureMessage(`Unexpected data field type: ${dataField.type}`, {
          extra: {
            dataField
          }
        });

        // This gets caught in the containing error boundary, which will fallback to the FE-rendered log event
        throw new Error(`Unexpected data field type: ${dataField.type}`);
      }
  }
};
const replaceTemplateNodes = (templateMessage, parsedDataFields) => {
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/g;
  const nodes = [];
  let lastIndex = 0;

  // Iterate through each matching placeholder in the template string and attempt to assign it a value in the resulting nodes array
  templateMessage.replace(placeholderRegex, (match, dataKey, index) => {
    if (index > lastIndex) {
      nodes.push(templateMessage.substring(lastIndex, index));
    }
    if (Object.prototype.hasOwnProperty.call(parsedDataFields, dataKey)) {
      nodes.push(parsedDataFields[dataKey]);
    } else {
      reportError({
        error: new Error(`Unhandled template placeholder found in logEventMessage: ${dataKey}`)
      });
      nodes.push(match);
    }
    lastIndex = index + match.length;
    return match;
  });

  // Push any remaining text after the last placeholder
  if (lastIndex < templateMessage.length) {
    nodes.push(templateMessage.substring(lastIndex));
  }
  return nodes;
};

/*
 * The meat and potatoes where the dynamic log events are interpolated with the appropriate data from the data map
 */
export const parseLogEventsMessage = (portalId, logEventMessage) => {
  const linkElements = logEventMessage.links.map(linkField => parseDataField(portalId, linkField));
  const parsedDataFields = Object.fromEntries(Object.entries(logEventMessage.messageData).map(([dataKey, dataField]) => [dataKey, parseDataField(portalId, dataField)]));
  const messageNodeArray = replaceTemplateNodes(logEventMessage.message, parsedDataFields);
  const detailsMessageNodeArray = logEventMessage.messageDetails ? replaceTemplateNodes(logEventMessage.messageDetails, parsedDataFields) : [];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      children: messageNodeArray.map((node, index) => /*#__PURE__*/_jsx(Fragment, {
        children: node
      }, index))
    }), logEventMessage.messageDetails && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("span", {
        "data-test-id": "log-event-message-details",
        children: [/*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "dynamicLogEvents.detailsLabel"
          })
        }), "\xA0", detailsMessageNodeArray.map((node, index) => /*#__PURE__*/_jsx(Fragment, {
          children: node
        }, index))]
      })
    }), linkElements.map((link, index) => /*#__PURE__*/_jsx("span", {
      children: link
    }, index))]
  });
};